export interface Testimonial {
  name: string;
  role: string;
  company: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '张明华',
    role: '产品经理',
    company: '某互联网科技公司',
    content: '娜娜轻量版是我用过最清爽的效率工具。没有花里胡哨的功能堆砌，每一个功能都恰到好处。启动速度快得让人惊喜，完全改变了我对应用软件的认知。',
    rating: 5,
  },
  {
    name: '李思琪',
    role: '自由设计师',
    company: '独立工作室',
    content: '作为一个同时管理多个项目的自由职业者，娜娜轻量版帮我从工具切换的泥潭中解脱出来。现在所有事情在一个应用里搞定，效率翻倍不是夸张。',
    rating: 5,
  },
  {
    name: '王建国',
    role: '技术总监',
    company: '某SaaS企业',
    content: '我们团队15个人统一切换到娜娜轻量版后，协作效率明显提升。特别是它的权限管理和共享空间功能，恰到好处地满足了小团队的需求，没有过度设计。',
    rating: 5,
  },
  {
    name: '赵晓琳',
    role: '研究生',
    company: '北京大学',
    content: '论文写作期间全靠娜娜轻量版来管理文献笔记和写作进度。番茄钟功能帮我保持了每天6小时的深度专注，最终提前一个月完成了论文。',
    rating: 5,
  },
  {
    name: '陈志远',
    role: '创业者',
    company: '某初创公司',
    content: '创业初期团队只有5个人，预算有限。娜娜轻量版免费又强大，完美覆盖了项目管理、文档协作和日程安排的需求。毫不夸张地说，它是我们团队的效率基石。',
    rating: 5,
  },
  {
    name: '刘美玲',
    role: '内容创作者',
    company: '自媒体工作室',
    content: '作为内容创作者，每天要处理选题、写稿、发布、数据分析等多个环节。娜娜轻量版帮我建立了清晰的创作流程，内容产出量提升了40%。',
    rating: 5,
  },
];